import { Flex, Heading, Text, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CustomButton, Layout } from "@lubbezposrednio-frontend/commons";

interface Screen404nProps {
  mainPageUrl?: string;
}

export const Screen404: React.FC<Screen404nProps> = ({ mainPageUrl }) => {
  useEffect(() => {
    document.title = "Nie znaleziono strony";
  }, []);

  return (
    <Layout redirectBaseUrl={mainPageUrl}>
      <VStack flex={1} justify="center" align="center" textAlign="center" minH="60vh" px="24px" py={{ base: "60px", md: "80px" }} spacing="6px">
        <Heading
          fontSize={{ base: "96px", md: "150px" }}
          fontWeight="900"
          lineHeight="1"
          letterSpacing="-0.03em"
          bgGradient="linear(135deg, #430098, #E51F44)"
          bgClip="text"
        >
          404
        </Heading>
        <Heading fontSize={{ base: "23px", md: "28px" }} fontWeight="800" color="primary" mt="10px">
          Nie znaleziono strony
        </Heading>
        <Text fontSize={{ base: "15px", md: "16px" }} color="gray.500" maxW="420px" mt="4px">
          Strona, której szukasz, nie istnieje lub została przeniesiona.
        </Text>
        <Flex pt="24px">
          <Link to={mainPageUrl ?? "/"} tabIndex={-1}>
            <CustomButton text="Strona główna" backgroundColor="accent" />
          </Link>
        </Flex>
      </VStack>
    </Layout>
  );
};
